import {
  APP_FETCH_ERROR,
  APP_FETCH_STARTED,
  APP_FETCH_SUCCESS,
  CLOSE_PASSWORD_MODAL,
  OPEN_PASSWORD_MODAL,
  POP_NOTIFICATION,
  PUSH_NOTIFICATION,
} from '../../constants';

// Network ////////////////////////////////////////////////////////////////////
const fetchStarted = (action, newState) => {
  const statusKey = action.payload;

  newState.status[statusKey] = {
    error: false,
    status: 'loading',
  };

  return newState;
};

const fetchSuccess = (action, newState) => {
  const statusKey = action.payload;

  if (statusKey) {
    newState.status[statusKey] = {
      error: false,
      status: 'success',
    };
  }

  newState.timestamp = new Date();

  return newState;
};

const fetchError = (action, newState) => {
  const { error, statusKey } = action.payload;

  if (statusKey) {
    newState.status[statusKey] = {
      status: 'error',
      error,
    };
  }

  newState.timestamp = new Date();

  return newState;
};

// Password modal /////////////////////////////////////////////////////////////
const openPasswordModal = (action, newState) => {
  newState.passwordModal.isOpen = true;

  return newState;
};

const closePasswordModal = (action, newState) => {
  newState.passwordModal.isOpen = false;

  return newState;
};

// Notifications //////////////////////////////////////////////////////////////
const pushNotification = (action, newState) => {
  const newMessages = [...newState.messages];

  newMessages.push(action.payload);
  newState.messages = newMessages;

  return newState;
};

const popNotification = (action, newState) => {
  const newMessages = [...newState.messages];

  newMessages.shift();
  newState.messages = newMessages;

  return newState;
};

// Cookie Test ////////////////////////////////////////////////////////////////
const updateCookieStatus = (action, newState) => {
  const tests = action.payload;

  newState.status = {...newState.status, tests};

  return newState;
}

const lookUp = {
  [APP_FETCH_STARTED]: fetchStarted,
  [APP_FETCH_SUCCESS]: fetchSuccess,
  [APP_FETCH_ERROR]: fetchError,

  // Password Modal
  [OPEN_PASSWORD_MODAL]: openPasswordModal,
  [CLOSE_PASSWORD_MODAL]: closePasswordModal,

  // Notifications
  [PUSH_NOTIFICATION]: pushNotification,
  [POP_NOTIFICATION]: popNotification,

  // Cookie test
  ['COOKIE_STATUS']: updateCookieStatus,
};

const initState = {
  pageLoading: false,
  fetchLookup: {},
  status: {
    login: { error: false, status: '' },
    passwordModal: { error: false, status: '' },
    mfa: { error: false, status: '' },
    tests: {error: false, status: ''},
  },
  passwordModal: { isOpen: false },
  messages: [],
  timestamp: new Date(),
};

const AppReducer = (state = initState, action) => {
  const { cmd } = action;

  if (lookUp[cmd]) return lookUp[cmd](action, { ...state });

  return state;
};
export default AppReducer;
